import React from 'react';
import { AddPartitionItemsListItem } from './add-partition-items-list-item';
import { ItemListOption } from '@/contexts/item-context-types';
import { OrderableItemListItemContent } from '@/components/orders/orderable-item-list-item-content';
import { Partition } from '@/hooks/use-edit-order-guide-reducer';
import { StyleSheet, View } from 'react-native';

// Map of variantPackUUID to itemUUID
export interface VariantPackItemMap {
  [variantPackUUID: string]: string;
}

interface Props {
  option: ItemListOption;
  partition: Partition;
  variantPackItemMap: VariantPackItemMap;
}

export const AddPartitionItemsListRowContent: React.FC<Props> = ({
  option,
  partition,
  variantPackItemMap,
}) => {
  return (
    <View style={styles.base}>
      <OrderableItemListItemContent
        containerStyle={styles.contentContainer}
        option={option}
        style={styles.content}
      />
      {option.metadata?.skus.map((sku) => {
        const itemUUID = variantPackItemMap[sku.variantPackUUID];
        return (
          <AddPartitionItemsListItem
            itemUUID={itemUUID}
            key={sku.variantPackUUID}
            option={option}
            partition={partition}
            sku={sku}
          />
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  base: {
    flex: 1,
    paddingVertical: 12,
  },
  content: {
    flex: 1,
  },
  contentContainer: {
    marginBottom: 4,
  },
});
